export enum LocalStorageEnum {
    RefreshToken = 'refresh_token',
    TokenSensedia = 'token_s'
}